import { render, staticRenderFns } from "./ReportTrainingFilter.vue?vue&type=template&id=1247423a&"
import script from "./ReportTrainingFilter.vue?vue&type=script&lang=ts&"
export * from "./ReportTrainingFilter.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports